// extracted by mini-css-extract-plugin
export default {"page_header":"PageHeader_page_header__jDGc5","page_header_content":"PageHeader_page_header_content__74bWk"};